import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportNote from '../../../../components/ReportNote';
import ReportCard from '../../../../components/ReportCard';
import StyledNotesContainer from '../StyledNotesContainer';

const AdvanceReportNotes = ({ isLhb, pitcherId, levelId }) => {
    const { t: translate } = useTranslation();

    const [hasAdvanceReportNote, setHasAdvanceReportNote] = useState(true);

    return hasAdvanceReportNote ? (
        <ReportCard title={translate('pitcher-overview.sections.advance-report')}>
            <StyledNotesContainer>
                <ReportNote
                    type={levelId === 8 ? 'oppp' : 'mnhp'}
                    section={isLhb ? 232 : 231}
                    playerId={pitcherId}
                    levelId={levelId}
                    hasDataCallback={setHasAdvanceReportNote}
                />
            </StyledNotesContainer>
        </ReportCard>
    ) : <></>;
};

export default AdvanceReportNotes;
